// src/routes/Login/AuthSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  token: null,
};

const AuthSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    logout(state) {
      state.user = null;
      state.token = null;
    },
    login(state, action) {
      state.user = action.payload;
      state.token = action.payload.access;
    },
    setAccessToken(state, action) {
      state.token = action.payload.access;
    },
    setLoanType(state, action) {
      state.user.selected_loan_type = action.payload;
    },
    updateUser(state, action) {
      state.user = { ...state.user, ...action.payload };
    },
  },
});

export const { logout, login, setAccessToken, setLoanType, updateUser } = AuthSlice.actions;
export default AuthSlice.reducer;
